/* global $:false */

import 'modernizr.js'

export default class LotThumbnail {
  static init () {
    if (window.Modernizr.touchevents) { return }
    if (!($('[data-thumbnail-slider-container]').length > 0)) { return }
    $('[data-thumbnail-slider-container]').each((index, element) => {
      const e = $(element)
      e.hover(() => {
        this.showSlider(e)
      }
      , () => {
        this.hideSlider(e)
        this.resetToPrimaryImage(e)
      })

      e.mousemove(event => {
        this.updatePreview(event, e)
      })
    })
  }

  static showSlider (e) {
    const slider = e.find('[data-thumbnail-slider]')
    slider.show()
  }

  static hideSlider (e) {
    const slider = e.find('[data-thumbnail-slider]')
    slider.hide()
  }

  static updatePreview (event, e) {
    const imageTag = e.find('[data-thumbnail-image]')
    const thumbnails = imageTag.data('thumbnails')
    const parentContainer = e.find('[data-thumbnail-image]')
    const width = parentContainer.width()
    const offset = parentContainer.offset()

    let relativeX = (event.pageX - offset.left)
    if (relativeX < 0) {
      relativeX = 0
    }

    const columnWidth = width / thumbnails.length
    const index = Math.floor(relativeX / columnWidth)
    imageTag.attr('src', thumbnails[index])

    const bullet = e.find(`[data-thumbnail-index=${index}]`)
    bullet.siblings().removeClass('active')
    bullet.addClass('active')
  }

  static resetToPrimaryImage (e) {
    const imageTag = e.find('[data-thumbnail-image]')
    const thumbnails = imageTag.data('thumbnails')
    imageTag.attr('src', thumbnails[0])
  }
}
